<div class="error-panel">
	<div class="error-icon-container">
		<mat-icon class="error-icon"
				  color="primary">info
		</mat-icon>
	</div>
	<p>{{ message | translate }}</p>
</div>